import React from 'react';
import useTranslation from '../../../Hooks/useTranslation';
import RemoveButton from '../../../Components/Button/RemoveButton';
import { EPrescriptionIPLPMedicament } from './EPrescriptionMedicamentsIPLPForm';
import styles from './EPrescriptionMedicamentsListItem.module.scss';
import LinkButton from '../../../Components/Button/LinkButton';
import { Theme } from '../../../Enums/Theme.enum';

interface EPrescriptionMedicamentsListItemIPLPProps {
	item: EPrescriptionIPLPMedicament;
	onRemove: (item: EPrescriptionIPLPMedicament) => void;
	onEdit: (item: EPrescriptionIPLPMedicament) => void;
}

const EPrescriptionMedicamentsListItemIPLP: React.FC<
	EPrescriptionMedicamentsListItemIPLPProps
> = ({ item, onRemove, onEdit }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<div className={styles.row}>
					<div className={styles.title}>
						<div className={styles.value}>
							{item.name ?? t('base.shared.notSpecified')}
						</div>
						<div className={styles.controls}>
							<RemoveButton
								onClick={() => onRemove(item)}
								title='base.shared.remove'
							/>
							<LinkButton
								theme={Theme.BLUE}
								onClick={() => onEdit(item)}
								title='base.shared.edit'
							/>
						</div>
					</div>
				</div>
				<div className={styles.row}>
					<div className={styles.item}>
						<div className={styles.name}>
							{t('component.ePrescription.preparationProcedure')}
						</div>
						<div className={styles.value}>{item.instruction}</div>
					</div>
				</div>
				<div className={styles.row}>
					<div className={styles.item}>
						<div className={styles.name}>
							{t('component.ePrescription.dosage')}
						</div>
						<div className={styles.value}>{item.manual}</div>
					</div>
				</div>
				<hr style={{ width: '100%' }} />
				<div className={styles.row}>
					<div className={styles.item}>
						<div className={styles.name}>
							{t('component.ePrescription.amount')}
						</div>
						<div className={styles.value}>{item.quantity}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.name}>
							{t('component.ePrescription.payment')}
						</div>
						<div className={styles.value}>
							{item.payment?.label ?? t('base.shared.notSpecified')}
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.name}>
							{t('component.ePrescription.notToBeMistaken')}
						</div>
						<div className={styles.value}>
							{item.doNotConfuse ? t('base.yes') : t('base.no')}
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.name}>
							{t('component.ePrescription.overStep')}
						</div>
						<div className={styles.value}>
							{item.overrun ? t('base.yes') : t('base.no')}
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.name}>{t('base.shared.diagnosis')}</div>
						<div className={styles.value}>
							{item.diagnosis?.label ?? t('base.shared.notSpecified')}
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.name}>
							{t('component.ePrescription.additionalDiagnosis')}
						</div>
						<div className={styles.value}>
							{item.associatedDiagnosis?.label ?? t('base.shared.notSpecified')}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default EPrescriptionMedicamentsListItemIPLP;
